// components/PatientHeader.jsx
import React from 'react';
import { Avatar, Button, Typography } from 'antd';
import { MailOutlined, HomeOutlined, PlusOutlined } from '@ant-design/icons';
import PropTypes from 'prop-types';
import { getImg } from '../../Api/getImg';
import InvoiceModal from '../Screens/BookingsScreen/InvoiceModal';
import { FaFileInvoiceDollar } from 'react-icons/fa';


const { Title, Text } = Typography;
const role= localStorage.getItem("role");
const PatientHeader = ({ patient }) => {
  const defaultImage = "https://res.cloudinary.com/dk2uh7sho/image/upload/v1750278754/default-img_tbc2pe.jpg";
  const [invoiceModalVisible, setInvoiceModalVisible] = React.useState(false);
  return (
    <div className='flex items-center justify-between mt-2 '>

    <div className="flex items-center gap-4 mb-6">
      <Avatar 
        src={getImg(patient.imageId) || defaultImage} 
        size={100} 
        alt={`${patient.fullName} profile`}
      />
      <div>
        <Title level={3} className="!mb-1 text-[#298d9f]">
          {patient.fullName}
        </Title>
        <Text type="secondary" className="block">
         ID:  {patient?.accountId}
        </Text>
        <Text type="secondary" className="block">
          <MailOutlined /> {patient.email}
        </Text>
        <Text type="secondary" className="block">
          <HomeOutlined /> {patient.clinics?.[0]?.name || 'N/A'}
        </Text>
      </div>
      
    </div>
{role!=4&&(
    <Button icon={<FaFileInvoiceDollar />} size='large' type="" className="mb-6 bg-primary text-white " onClick={() => setInvoiceModalVisible(true)}>
      Create Invoice
    </Button>)}
    <InvoiceModal patient={patient} visible={invoiceModalVisible} onCancel={() => setInvoiceModalVisible(false)}  />
    </div>
  );
};

PatientHeader.propTypes = {
  patient: PropTypes.shape({
    fullName: PropTypes.string.isRequired,
    email: PropTypes.string.isRequired,
    imageId: PropTypes.string,
    clinics: PropTypes.arrayOf(PropTypes.shape({
      name: PropTypes.string
    }))
  }).isRequired
};

export default PatientHeader;